import React, { useState, useEffect } from "react";

import axios from "axios";
import { server } from "../../../utills/utils";

import Spinner from "../../Modals/SpinnerModal";
import Modal from "../../Modals/CancelModal";
import ShopItem from "./SubOffShop";

import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 5px;
  display: flex;
  flex-flow: wrap;
`;

const Shop = styled.div`
  width: 43%;
  height: 180px;
  background: yellow;
  margin: 0 2% 2% 0;
  background: white;
  border: 1px solid #eee;
  padding: 2%;
`;
const ShopTitle = styled.h3`
  font-weight: 500;
  margin: 0;
  padding: 5px 0;
`;
const SecondTitle = styled.p`
  margin: 0;
  padding: 3px 0;
  color: gray;
`;
const Button1 = styled.button`
  width: 48.5%;
  padding: 10px;
  margin: 5px 5% 0 0;
  font-size: 1em;
  background: #ff5d5d;
  border: none;
  color: white;
  border-radius: 5px;
  cursor: pointer;
`;
const Button2 = styled.button`
  width: 45%;
  padding: 10px;
  border: none;
  border-radius: 5px;
  font-size: 1em;
  cursor: pointer;
`;
const CancelTitle = styled.p``;
// const ShopItem = (props) => {
//   return (
//     <Shop>
//       <ShopTitle>{props.shop.name}</ShopTitle>
//       <SecondTitle>{props.shop.phone}</SecondTitle>
//       <SecondTitle>{props.shop.email}</SecondTitle>
//       <SecondTitle>
//         {props.shop.cityName}, {props.shop.thanaName}
//       </SecondTitle>
//       <Button1
//         onClick={() => {
//           props.blockModaHandler(props.shop._id);
//         }}
//       >
//         Block
//       </Button1>
//       {/* <Button2 onClick={() => props.cancelModaHandler(props.shop._id)}>
//         Cancel
//       </Button2> */}
//     </Shop>
//   );
// };

function ShopsRequest() {
  const [shops, setShops] = useState([]);
  const [complete, setComplete] = useState(false);
  const [block, setBlock] = useState(false);
  const [blockId, setBlockId] = useState(null);
  const [spinner, setSpinner] = useState(false);

  const fetchShops = async (args, req) => {
    try {
      const shops = await axios.post(server, {
        query: `
                    query{
                        subscriptionOffShops{
                           _id
                            name
                            phone
                            email
                            cityName
                            thanaName
                            categoryName
                        }
                    }
                  `,
      });
      setShops(shops.data.data.subscriptionOffShops);
      setComplete(true);
    } catch (error) {
      throw error;
    }
  };

  const onBoardShop = async (shopId, days) => {
    try {
      console.log("Days", days);
      setSpinner(true);
      let date = new Date();
      date.setDate(date.getDate() + days);
      console.log("Date", date.toISOString());

      const shop = await axios.post(server, {
        query: `
                    mutation{
                        onBoardShop(shopId:"${shopId}", date:"${date.toISOString()}"){
                          _id
                          name
                          phone
                          email
                          location
                        }
                    }
                  `,
      });
      const newShops = shops.filter((shop) => {
        return shop._id !== shopId;
      });
      setShops(newShops);
      setSpinner(false);
    } catch (error) {
      throw error;
    }
  };

  const blockModaHandler = (id) => {
    setBlock(true);
    setBlockId(id);
  };
  const blockCloseHandler = () => {
    setBlock(false);
    setBlockId(null);
  };

  useEffect(() => {
    fetchShops();
  }, []);
  return (
    <div>
      <Spinner show={spinner} />

      {/* <Modal show={block} closeModal={blockCloseHandler}>
        <CancelTitle>Are you sure want to block this shop ?</CancelTitle>
        <Button1
          onClick={() => {
            shopBlockHandler(blockId);
          }}
        >
          Yes
        </Button1>
        <Button2 onClick={blockCloseHandler}>No</Button2>
      </Modal> */}

      {complete ? (
        <Container>
          {shops.map((shop) => {
            return (
              <ShopItem
                onBoardHandler={onBoardShop}
                key={shop._id}
                shop={shop}
              />
            );
          })}
        </Container>
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
}

export default ShopsRequest;
